import React from 'react'
import { Link } from 'gatsby'
import ReactWOW from 'react-wow';
const Footer = () => {
  return(
    <footer className="new_footer_area bg_color">
        <div className="new_footer_top">
            <div className="container">
                <div className="row" style={{justifyContent:'space-between'}}>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <ReactWOW animation="fadeInLeft" delay="0.2s">
                        <div className="f_widget company_widget">
                            <h3 className="f-title f_600 t_color f_size_18">Regístrese</h3>
                            <p>¡Regístrese ahora, es fácil y rápido iniciar y no requiere de tarjeta de crédito!</p>
                            <Link to="/signup/es">
                                <button type="submit" className="btn_hover btn_get">Empiece Ahora</button>
                            </Link>
                        </div>
                        </ReactWOW>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <ReactWOW animation="fadeInLeft" delay="0.4s">
                        <div className="f_widget about-widget pl_70">
                            <h3 className="f-title f_600 t_color f_size_18">Nosotros</h3>
                            <ul className="list-unstyled f_list">
                                {/* <li><Link to="/">What is Workhub</Link></li> */}
                                <li><Link to="/features/">Características</Link></li>
                                <li><Link to="/pricing/">Precios</Link></li>
                            </ul>
                        </div>
                        </ReactWOW>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                    <ReactWOW animation="fadeInLeft" delay="0.8s">
                        <div className="f_widget social-widget">
                            <h3 className="f-title f_600 t_color f_size_18">Contacto </h3>
                            <div className="widget-wrap">
                                <h4 style={{fontSize: '1rem'}}>Soporte:</h4>
                                <p className="f_400 f_p f_size_15 mb-0 mt-2"><a href="mailto:support@workhub.com" className="f_400" style={{height: '48px'}}>support@workhub.com</a></p>
                                <br />
                                <h4 style={{fontSize: '1rem'}}>Ventas:</h4>
                                <p className="f_400 f_p f_size_15 mb-0 mt-2"><a href="mailto:sales@workhub.com" className="f_400" style={{height: '48px'}}>sales@workhub.com</a></p>
                            </div>
                            <br />
                            <div className="f_social_icon">
                                <a href="https://www.facebook.com/workhubsoftware/" target="_blank" rel="noopener noreferrer" className="ti-facebook" aria-label="Workhub Facebook"><img style={{display: 'inline'}}src="/app-icons/layout-icons/facebook.svg" alt="Facebook Icon"/></a>
                                <a href="https://instagram.com/workhubsoftware" target="_blank" rel="noopener noreferrer" className="ti-instagram" aria-label="Workhub Instagram"><img style={{display: 'inline'}} src="/app-icons/layout-icons/instagram.svg" alt="Instagram Icon"></img></a>
                                <a href="https://twitter.com/workhubsoftware" target="_blank" rel="noopener noreferrer" className="ti-twitter-alt" aria-label="Workhub Twitter"><img style={{display: 'inline'}}src="/app-icons/layout-icons/x.svg" alt="X Icon"/></a>
                                <a href="https://www.linkedin.com/company/3741519" target="_blank" rel="noopener noreferrer" className="ti-linkedin" aria-label="Workhub LinkedIn"><img style={{display: 'inline'}}src="/app-icons/layout-icons/linkedin.svg" alt="LinkedIn Icon"/></a>
                                <a href="https://www.youtube.com/channel/UC7jQkB2O_sVOUsylseAp9RA" target="_blank" rel="noopener noreferrer" className="ti-youtube" aria-label="Workhub Youtube"><img style={{display: 'inline'}}src="/app-icons/layout-icons/youtube-small.svg" alt="Youtube Icons"/></a>
                            </div>
                                                            
                        </div>
                            </ReactWOW>
                    </div>
                </div>
            </div>
            {/* <div className="footer_bg">
                <div className="footer_bg_one"></div>
                <div className="footer_bg_two"></div>
            </div> */}
        </div>
        <div className="footer_bottom">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-sm-8" style={{display: 'flex', flexDirection: 'flex-row', flexWrap: 'wrap'}}>
                        <div className="footer-copy"><p>© Workhub Software Corp. 2023 All rights reserved.</p></div>
                        <div className="footer-links">
                            <Link className="mx-2 f_400" to="/privacy" style={{width: 'max-content'}}>Privacy Policy</Link>
                            <p className=" f_400 footer-pipe">|</p>
                            <Link className="mx-2 f_400" to="/terms/" style={{width: 'max-content'}}>Terms & Conditions</Link>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-4 text-right">
                        <p>Made with <img src="/app-icons/layout-icons/heart-black.svg" alt="Black Heart"/> by <Link to="/">Workhub</Link></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer